import axios from "axios";

const AUTH_URL = process.env.REACT_APP_AUTH_URL;

console.log("Loaded AUTH_URL:", AUTH_URL);

// Set up a base Axios instance
const authClient = axios.create({
  baseURL: AUTH_URL, // optional
  headers: {
    "Content-Type": "application/json",
  },
});

// Generic API caller
const callAuthApi = async ({ url, method = "GET", params = {}, data = {} }) => {
  try {
    const response = await authClient({
      url,
      method,
      params,
      data,
    });
    return response.data;
  } catch (error) {
    console.error("Auth API Error:", error);
    throw error;
  }
};

export default callAuthApi
